import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SerenityNgxModule } from '@insight/serenity-ngx';
import { Directive, TemplateRef, Injectable, forwardRef, Component, ContentChildren, Input, Output, EventEmitter, Pipe, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnScaffoldingContentDirective = /** @class */ (function () {
    function SnScaffoldingContentDirective(templateRef) {
        this.templateRef = templateRef;
    }
    SnScaffoldingContentDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'ng-template[snScaffoldingContent]'
                },] }
    ];
    /** @nocollapse */
    SnScaffoldingContentDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    return SnScaffoldingContentDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnScaffoldingSubnavDirective = /** @class */ (function () {
    function SnScaffoldingSubnavDirective(templateRef) {
        this.templateRef = templateRef;
    }
    SnScaffoldingSubnavDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'ng-template[snScaffoldingSubnav]'
                },] }
    ];
    /** @nocollapse */
    SnScaffoldingSubnavDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    return SnScaffoldingSubnavDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @ignore
 */
var ConfigProvider = /** @class */ (function () {
    function ConfigProvider() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    ConfigProvider.prototype.setConfig = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        ConfigProvider.config = config;
    };
    ConfigProvider.config = {};
    return ConfigProvider;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @ignore
 * @type {?}
 */
var config = forwardRef((/**
 * @return {?}
 */
function () { return ConfigProvider.config; }));
var SnAppListService = /** @class */ (function () {
    function SnAppListService(http) {
        this.http = http;
    }
    Object.defineProperty(SnAppListService.prototype, "cfg", {
        /**
         * @ignore
         */
        get: /**
         * @ignore
         * @return {?}
         */
        function () {
            return new config();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SnAppListService.prototype.getAll = /**
     * @return {?}
     */
    function () {
        return this.http
            .get(this.cfg.apiRoot + "/globalNavItems?where=not(strcontains(url,Url-))")
            .pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            /** @type {?} */
            var items = ((/** @type {?} */ (res))).results;
            items.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.index - b.index; }));
            return items;
        })));
    };
    SnAppListService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SnAppListService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return SnAppListService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnScaffoldingComponent = /** @class */ (function () {
    function SnScaffoldingComponent(appList) {
        this.appList = appList;
        this.logout = new EventEmitter();
        /**
         * @ignore
         */
        this.collapsed = true;
        /**
         * @ignore
         */
        this.apps = [];
    }
    /**
     * @return {?}
     */
    SnScaffoldingComponent.prototype.ngAfterContentChecked = /**
     * @return {?}
     */
    function () {
        this.contentTmpl =
            this.contentTmpls.first && this.contentTmpls.first.templateRef;
        this.subnavTmpl =
            this.subnavTmpls.first && this.subnavTmpls.first.templateRef;
    };
    /**
     * @return {?}
     */
    SnScaffoldingComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.user && this.user.partyMemberId) {
            this.appList.getAll().subscribe((/**
             * @param {?} apps
             * @return {?}
             */
            function (apps) {
                _this.apps = apps.map((/**
                 * @param {?} app
                 * @return {?}
                 */
                function (app) {
                    app.active = app.url.includes(window.location.origin);
                    return app;
                }));
            }));
        }
    };
    /**
     * @return {?}
     */
    SnScaffoldingComponent.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.collapsed = !this.collapsed;
    };
    /**
     * @return {?}
     */
    SnScaffoldingComponent.prototype.quit = /**
     * @return {?}
     */
    function () {
        this.logout.emit();
    };
    SnScaffoldingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-scaffolding',
                    template: "\n        <div class=\"scaffold-topbar-wrapper\">\n            <div\n                class=\"scaffold-hamburger\"\n                [ngClass]=\"{ collapsed: collapsed }\"\n                (click)=\"toggle()\"\n            >\n                <i class=\"fas fa-bars\"></i>\n            </div>\n            <div class=\"scaffold-topbar\">\n                <sn-topbar [user]=\"user\" (logout)=\"quit()\"></sn-topbar>\n            </div>\n        </div>\n        <div class=\"scaffold-application-wrapper\">\n            <div class=\"scaffold-sidebar\" [ngClass]=\"{ collapsed: collapsed }\">\n                <sn-sidebar [apps]=\"apps\"></sn-sidebar>\n            </div>\n            <div\n                class=\"scaffold-subnav\"\n                [ngStyle]=\"{\n                    display: subnavTmpl ? 'initial' : 'none'\n                }\"\n            >\n                <ng-template [ngTemplateOutlet]=\"subnavTmpl\"></ng-template>\n            </div>\n            <div class=\"scaffold-content\">\n                <ng-template [ngTemplateOutlet]=\"contentTmpl\"></ng-template>\n            </div>\n        </div>\n    ",
                    styles: ["\n            .scaffold-hamburger {\n                background: #148dca;\n                transition: 0.2s;\n            }\n\n            .scaffold-hamburger.collapsed {\n                background: #0af;\n            }\n\n            .scaffold-sidebar {\n                margin-left: 0;\n                transition: 0.2s;\n            }\n\n            .scaffold-sidebar.collapsed {\n                margin-left: -75px;\n            }\n        "]
                }] }
    ];
    /** @nocollapse */
    SnScaffoldingComponent.ctorParameters = function () { return [
        { type: SnAppListService }
    ]; };
    SnScaffoldingComponent.propDecorators = {
        logout: [{ type: Output }],
        user: [{ type: Input }],
        contentTmpls: [{ type: ContentChildren, args: [SnScaffoldingContentDirective, {
                        descendants: false
                    },] }],
        subnavTmpls: [{ type: ContentChildren, args: [SnScaffoldingSubnavDirective, {
                        descendants: false
                    },] }]
    };
    return SnScaffoldingComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnSidebarComponent = /** @class */ (function () {
    function SnSidebarComponent() {
        this.apps = [];
    }
    SnSidebarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-sidebar',
                    template: "\n        <div class=\"sidebar\">\n            <a\n                *ngFor=\"let app of apps\"\n                class=\"sidebar-link\"\n                [ngClass]=\"{ active: app.active }\"\n                href=\"{{ app.url }}\"\n            >\n                <div class=\"sidebar-icon\">\n                    <i class=\"fas fa-fw {{ app.icon }}\"></i>\n                </div>\n                <div class=\"sidebar-label\">{{ app.name }}</div>\n            </a>\n            <div *ngIf=\"apps.length === 0\">\n                <a class=\"sidebar-link\" *ngFor=\"let i of [1, 2, 3, 4, 5]\">\n                    <div><i class=\"fas fa-square shimmer\"></i></div>\n                    <div><i class=\"fas fa-minus shimmer\"></i></div>\n                </a>\n            </div>\n        </div>\n    ",
                    styles: ["\n            .shimmer {\n                display: inline-block;\n                color: white;\n                background: #acacac -webkit-gradient(linear, 100% 0, 0 0, from(#acacac), color-stop(0.5, #ffffff), to(#acacac));\n                background-position: -4rem top;\n                background-repeat: no-repeat;\n                -webkit-background-clip: text;\n                -webkit-text-fill-color: transparent;\n                -webkit-animation-name: shimmer;\n                -webkit-animation-duration: 1s;\n                -webkit-animation-iteration-count: infinite;\n                -webkit-background-size: 4rem 100%;\n                font-size: 30px;\n            }\n\n            @-webkit-keyframes shimmer {\n                0% {\n                    background-position: -4rem top;\n                }\n                70% {\n                    background-position: 12.5rem top;\n                }\n                100% {\n                    background-position: 12.5rem top;\n                }\n            }\n        "]
                }] }
    ];
    SnSidebarComponent.propDecorators = {
        apps: [{ type: Input }]
    };
    return SnSidebarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable:max-line-length */
var SnTopbarComponent = /** @class */ (function () {
    function SnTopbarComponent() {
        this.logout = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SnTopbarComponent.prototype.quit = /**
     * @return {?}
     */
    function () {
        this.logout.emit();
    };
    SnTopbarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-topbar',
                    template: "\n        <nav class=\"navbar navbar-serenity\">\n            <a class=\"navbar-brand\" href=\"/\">\n                <svg version=\"1.1\"\n                    xmlns=\"http://www.w3.org/2000/svg\"\n                    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                    x=\"0px\"\n                    y=\"0px\"\n                    viewBox=\"0 0 253.1 37.29\"\n                    xml:space=\"preserve\">\n\n                    <g>\n                        <g>\n                            <path class=\"logo-fill\" d=\"M45.61,19.48c-0.98,0-1.48,0.79-1.61,1.77c-0.15,1.07-0.71,4.79-0.83,5.74c-0.08,0.56-0.12,1.16-0.67,1.4\n                                c-0.55,0.24-1.22-0.13-1.79-0.61c-0.57-0.48-9.01-7.67-9.01-7.67c-0.48-0.42-1.1-0.62-1.68-0.62c-1.27,0-2.5,0.79-2.5,2.73v11.98\n                                c0,0.94,0.66,1.53,1.44,1.53c0.87,0,1.43-0.57,1.55-1.42c0,0,0.93-5.71,1.04-6.35c0.13-0.74,0.25-1.32,0.96-1.54\n                                c0.65-0.2,1.26,0.18,2.17,0.97c0.9,0.79,8.5,7.65,8.5,7.65c0.58,0.49,1,0.69,1.83,0.69c0.75,0,2.1-0.3,2.1-2.59V21.2\n                                C47.13,20.09,46.45,19.48,45.61,19.48\" />\n                            <path class=\"logo-fill\" d=\"M100,32.26c-6.62,1.43-14.2-0.1-14.2-4.78c0-3.54,3.28-4.98,5.87-5.19c2.71-0.22,4.83,0.36,5.93,1.49\n                                c0.68,0.71,0.49,1.67-0.85,1.75c-1.24,0.07-3.55,0.14-5.48,0.22c-1.09,0.04-1.68,0.63-1.68,1.41c0,0.62,0.47,1.34,1.73,1.34\n                                c1.81,0.01,6.39,0.04,8.66,0.04c1.5,0,2.24-0.84,2.24-2.56c0-2.74-2.48-6.88-9.73-6.88c-6.57,0-11.33,3.27-11.33,8.62\n                                c0,7.59,11.17,9.91,19.35,7.09c0.78-0.27,1.48-0.82,1.25-1.69C101.56,32.34,100.94,32.05,100,32.26\" />\n                            <path class=\"logo-fill\" d=\"M23.14,32.26c-6.62,1.43-14.2-0.1-14.2-4.78c0-3.54,3.28-4.98,5.87-5.19c2.71-0.22,4.84,0.36,5.93,1.49\n                                c0.68,0.71,0.49,1.67-0.85,1.75c-1.23,0.07-3.55,0.14-5.47,0.22c-1.09,0.04-1.68,0.63-1.68,1.41c0,0.62,0.47,1.34,1.73,1.34\n                                c1.8,0.01,6.38,0.04,8.66,0.04c1.5,0,2.24-0.84,2.24-2.56c0-2.74-2.48-6.88-9.73-6.88c-6.57,0-11.33,3.27-11.33,8.62\n                                c0,7.59,11.17,9.91,19.35,7.09c0.77-0.27,1.48-0.82,1.25-1.69C24.71,32.34,24.08,32.05,23.14,32.26\" />\n                            <path class=\"logo-fill\" d=\"M74.45,24.96c0.14,4.14,0.53,7.57,0.65,8.77c0.14,1.55,0.94,1.99,1.75,1.99c0.77,0,1.59-0.4,1.73-1.98\n                                c0.12-1.32,0.51-5.42,0.7-9.47c0.01-0.21-0.14-0.3-0.31-0.27l-4.31,0.7C74.54,24.73,74.45,24.83,74.45,24.96\" />\n                            <path class=\"logo-fill\" d=\"M76.86,19.09c-1.98,0-2.56,1.55-2.53,2.5c0,0.18,0.02,0.67,0.05,1.27c0,0.14,0.13,0.27,0.29,0.25l4.5-0.73\n                                c0.14-0.03,0.21-0.13,0.22-0.25c0.01-0.21,0.02-0.43,0.02-0.53C79.44,20.69,78.85,19.09,76.86,19.09\" />\n                            <path class=\"logo-fill\" d=\"M70.24,25.69c-1.5,0-6.13,0.03-9.09,0.04c-1.44,0-1.8,0.77-1.8,1.41c0,0.56,0.39,1.27,1.73,1.35\n                                c2.04,0.11,4.64,0.23,5.84,0.29c1.62,0.08,1.64,0.91,1.09,1.62c-1.1,1.43-3.77,2.36-6.53,2.36c-3.62,0-7.6-2.06-7.6-5.32\n                                c0-3.06,3.41-6.43,13.53-5.01c0.89,0.12,1.77-0.03,1.99-0.86c0.23-0.88-0.34-1.44-1.49-1.74c-2.29-0.6-4.38-0.75-6.38-0.75\n                                c-6.81,0-12.28,3.25-12.28,8.51c0,5.61,5.44,8.36,12.23,8.36c7.58,0,11.27-4.12,11.27-7.73C72.75,26.39,71.81,25.69,70.24,25.69\" />\n                            <linearGradient id=\"SN-LOGO-GRADIENT\" gradientUnits=\"userSpaceOnUse\" x1=\"53.2731\" y1=\"16.527\" x2=\"53.2731\" y2=\"0.527\">\n                                <stop  offset=\"0\" style=\"stop-color:#FFFFFF;stop-opacity:0\" />\n                                <stop  offset=\"1\" style=\"stop-color:#FFFFFF\" />\n                            </linearGradient>\n                            <path class=\"logo-arch\" d=\"M0.77,16.53h105c0,0-20-16-53-16S0.77,16.53,0.77,16.53z\" />\n                        </g>\n                        <g>\n                            <path class=\"logo-fill\" d=\"M155.32,32.2l-0.05,1.97h-7.92v-12h7.68l0.03,2h-5.51v2.9h4.67v1.81h-4.67v3.33H155.32z\" />\n                            <path class=\"logo-fill\" d=\"M165.11,34.17l-5.12-7.31l-0.72-1.09l-0.03,0.02l0.02,1.3v7.09h-1.97v-12h1.92l4.79,7.01l0.72,1.07\n                                l0.03-0.02l-0.03-1.28v-6.79h1.95v12H165.11z\" />\n                            <path class=\"logo-fill\" d=\"M177.91,33.72c-0.88,0.4-2.24,0.67-3.54,0.67c-3.97,0-5.57-2.02-5.57-6.19c0-4.27,1.71-6.24,5.63-6.24\n                                c1.14,0,2.37,0.22,3.25,0.56l-0.22,1.97c-0.83-0.34-1.87-0.53-2.91-0.53c-2.51,0-3.43,0.96-3.43,4.21c0,3.23,0.85,4.19,3.19,4.19\n                                c0.62,0,1.17-0.08,1.65-0.22v-4.39h1.95V33.72z\" />\n                            <path class=\"logo-fill\" d=\"M180.34,22.16h2.24v12h-2.24V22.16z \"/>\n                            <path class=\"logo-fill\" d=\"M193.4,32.2l-0.05,1.97h-7.92v-12h7.68l0.03,2h-5.51v2.9h4.67v1.81h-4.67v3.33H193.4z\" />\n                            <path class=\"logo-fill\" d=\"M200.07,22.16h2.24v12h-2.24V22.16z\" />\n                            <path class=\"logo-fill\" d=\"M210.78,34.17v-6.23c0-1.22-0.66-1.73-1.84-1.73c-0.72,0-1.52,0.32-1.92,0.88v7.07h-2.03v-9.59l1.46-0.11\n                                l0.32,0.93c0.72-0.67,1.7-1.04,2.74-1.04c2.03,0,3.31,1.23,3.31,3.57v6.24H210.78z\" />\n                            <path class=\"logo-fill\" d=\"M217.61,34.36c-1.15,0-2.19-0.24-2.99-0.72l0.24-1.73c0.75,0.5,1.87,0.75,2.75,0.75\n                                c1.17,0,1.66-0.53,1.66-1.23c0-1.82-4.69-0.88-4.69-4.21c0-1.68,1.17-2.85,3.52-2.85c0.96,0,1.87,0.19,2.67,0.54l-0.18,1.7\n                                c-0.8-0.34-1.79-0.5-2.53-0.5c-0.96,0-1.54,0.38-1.54,1.02c0,1.7,4.62,0.75,4.62,4.1C221.16,33.11,220.1,34.36,217.61,34.36z\" />\n                            <path class=\"logo-fill\" d=\"M224.28,23.25c-0.82,0-1.22-0.24-1.22-0.94c0-0.62,0.4-0.98,1.22-0.98c0.83,0,1.22,0.35,1.22,0.98\n                                C225.5,22.95,225.11,23.25,224.28,23.25z M223.24,34.17v-9.57l2.06-0.11v9.68H223.24z\" />\n                            <path class=\"logo-fill\" d=\"M230.09,30.09c-0.32,0.13-0.51,0.34-0.51,0.58c0,0.27,0.22,0.5,0.72,0.53l2.32,0.16\n                                c2.29,0.16,3.1,0.96,3.1,2.39c0,1.86-1.2,3.03-4.27,3.03c-2.69,0-3.83-1.06-3.83-2.55c0-0.62,0.29-1.22,0.83-1.66\n                                c-0.43-0.27-0.75-0.74-0.75-1.38s0.38-1.23,1.2-1.6c-0.67-0.43-1.1-1.14-1.1-2.26c0-1.78,0.98-2.95,3.55-2.95\n                                c0.83,0,1.71,0.13,2.38,0.56l1.6-0.58l0.43,1.01l-1.07,0.8c0.13,0.32,0.19,0.7,0.19,1.15c0,1.84-0.98,2.88-3.54,2.88\n                                C230.92,30.2,230.49,30.17,230.09,30.09z M229.94,32.93c-0.37,0.3-0.58,0.69-0.58,1.02c0,0.8,0.59,1.23,2.03,1.23\n                                c1.99,0,2.48-0.46,2.48-1.15c0-0.54-0.3-0.83-1.62-0.93L229.94,32.93z M229.8,27.35c0,1.12,0.62,1.41,1.52,1.41\n                                c1.25,0,1.62-0.43,1.62-1.41c0-1.04-0.46-1.41-1.57-1.41C230.22,25.94,229.8,26.39,229.8,27.35z\" />\n                            <path class=\"logo-fill\" d=\"M243.1,34.17v-6.24c0-1.12-0.58-1.71-1.82-1.71c-0.85,0-1.58,0.38-1.92,0.9v7.06h-2.03V21.63l2.03-0.11v2.46\n                                l-0.03,1.28l0.05,0.03c0.72-0.67,1.63-0.94,2.54-0.94c2.05,0,3.23,1.3,3.23,3.57v6.24H243.1z\" />\n                            <path class=\"logo-fill\" d=\"M249.57,26.1v5.36c0,0.85,0.45,1.2,1.27,1.2c0.26,0,0.61-0.05,0.78-0.11l0.13,1.52\n                                c-0.32,0.14-0.91,0.26-1.5,0.26c-1.81,0-2.71-1.04-2.71-2.82V26.1h-1.2v-1.57h1.26l0.37-2.26l1.6-0.16v2.42h2.26v1.57H249.57z\" />\n                        </g>\n                        <g>\n                            <rect x=\"124.4\" y=\"19.28\" class=\"logo-fill\" width=\"1\" height=\"16.92\" />\n                        </g>\n                    </g>\n                </svg>\n            </a>\n\n            <ul class=\"navbar-nav ml-auto\">\n                <li class=\"nav-item dropdown\" ngbDropdown placement=\"bottom-right\" *ngIf=\"user && user.firstName\">\n                    <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle>\n                        <span class=\"pl-2\">\n                            <sn-letter-avatar [type]=\"'primary-inverse'\">\n                                {{ user | initials }}\n                            </sn-letter-avatar>\n                        </span>\n                    </a>\n                    <div class=\"dropdown-menu dropdown-menu-right\" ngbDropdownMenu>\n                        <h6 class=\"dropdown-header\">{{ user.firstName }} {{ user.lastName }}</h6>\n                        <div class=\"dropdown-divider\"></div>\n                        <a class=\"dropdown-item\" (click)=\"quit()\">Logout</a>\n                    </div>\n                </li>\n            </ul>\n        </nav>\n    ",
                    styles: ["\n        svg {\n            width: 200px;\n        }\n\n        .logo-arch {\n            fill:url(#SN-LOGO-GRADIENT);\n        }\n\n        .logo-fill {\n            fill: #fff;\n        }\n\n        .dropdown-item {\n            cursor: pointer;\n        }\n\n        .dropdown-toggle::after {\n            display: none;\n        }\n\n        sn-letter-avatar {\n            font-size: 14px;\n        }\n\n        .dropdown-header {\n            font-size: 12px;\n            text-transform: uppercase;\n        }\n\n        .dropdown {\n            left: 14px;\n        }\n    "]
                }] }
    ];
    SnTopbarComponent.propDecorators = {
        user: [{ type: Input }],
        logout: [{ type: Output }]
    };
    return SnTopbarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InitialsPipe = /** @class */ (function () {
    function InitialsPipe() {
    }
    /**
     * @param {?} user
     * @return {?}
     */
    InitialsPipe.prototype.transform = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        /** @type {?} */
        var f = user &&
            user.firstName &&
            user.firstName.length > 0 &&
            user.firstName.charAt(0).toUpperCase();
        /** @type {?} */
        var l = user &&
            user.lastName &&
            user.lastName.length > 0 &&
            user.lastName.charAt(0).toUpperCase();
        return "" + (f || '') + (l || '');
    };
    InitialsPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'initials'
                },] }
    ];
    return InitialsPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnSubnavComponent = /** @class */ (function () {
    function SnSubnavComponent() {
    }
    SnSubnavComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-subnav',
                    template: "\n        <div class=\"subnav\">\n            <ng-content></ng-content>\n        </div>\n    "
                }] }
    ];
    return SnSubnavComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SnSubnavLinkComponent = /** @class */ (function () {
    function SnSubnavLinkComponent() {
        this.badge = '';
    }
    SnSubnavLinkComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-subnav-link',
                    template: "\n        <div class=\"subnav-link\">\n            <span>\n                <ng-content></ng-content>\n            </span>\n            <span *ngIf=\"badge\" class=\"badge badge-secondary\">\n                {{ badge }}\n            </span>\n        </div>\n    "
                }] }
    ];
    SnSubnavLinkComponent.propDecorators = {
        badge: [{ type: Input }]
    };
    return SnSubnavLinkComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @ignore
 * @type {?}
 */
var configProvider = new ConfigProvider();
var SnScaffoldingModule = /** @class */ (function () {
    function SnScaffoldingModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    SnScaffoldingModule.setConfig = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        configProvider.setConfig(config);
    };
    SnScaffoldingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        HttpClientModule,
                        CommonModule,
                        NgbDropdownModule,
                        SerenityNgxModule
                    ],
                    declarations: [
                        SnScaffoldingComponent,
                        SnScaffoldingContentDirective,
                        SnScaffoldingSubnavDirective,
                        SnSidebarComponent,
                        SnTopbarComponent,
                        InitialsPipe,
                        SnSubnavComponent,
                        SnSubnavLinkComponent
                    ],
                    providers: [
                        SnAppListService
                    ],
                    exports: [
                        SnScaffoldingComponent,
                        SnScaffoldingContentDirective,
                        SnScaffoldingSubnavDirective,
                        SnSubnavComponent,
                        SnSubnavLinkComponent
                    ]
                },] }
    ];
    return SnScaffoldingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { SnScaffoldingComponent, SnScaffoldingModule, SnScaffoldingContentDirective, SnScaffoldingSubnavDirective, SnAppListService, InitialsPipe, SnSidebarComponent, SnSubnavLinkComponent, SnSubnavComponent, SnTopbarComponent as ɵa };

//# sourceMappingURL=insight-serenity-scaffolding.js.map